export const theme = {
  primaryDark: '#181E20',
  gris: '#a8a8a8',
  white: "#F2F4F5",
  primaryLight: '#024B8726',
  primaryHover: '#343078',
  mobile: '576px',
}